export async function removeQueryString(state: any) {
    await window.history.replaceState(null, '', state);
}